import { assertUnreachable } from '@dreryk/react-common';

import { Direction } from './HorizontalScrollerNavigation.types';

export const directionSelector = (direction: Direction) => <LEFT, RIGHT>(left: LEFT, right: RIGHT): LEFT | RIGHT => {
   switch (direction) {
      case 'left':
         return left;
      case 'right':
         return right;
      default:
         return assertUnreachable(direction);
   }
};

export const preventEdgeScrolling = (element: HTMLDivElement, event: WheelEvent): void => {
   const atLeftEdge = element.scrollLeft <= 0;
   const atRightEdge = Math.ceil(element.scrollLeft + element.clientWidth) >= element.scrollWidth;
   if ((atLeftEdge && event.deltaX < 0) || (atRightEdge && event.deltaX > 0)) {
      event.preventDefault();
   }
};
